import { render, staticRenderFns } from "./bp-mobile.vue?vue&type=template&id=a983caae&scoped=true"
import script from "./bp-mobile.vue?vue&type=script&lang=js"
export * from "./bp-mobile.vue?vue&type=script&lang=js"
import style0 from "./bp-mobile.vue?vue&type=style&index=0&id=a983caae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a983caae",
  null
  
)

export default component.exports